import { render, staticRenderFns } from "./FolderName.vue?vue&type=template&id=91f9e248&scoped=true&"
import script from "./FolderName.vue?vue&type=script&lang=js&"
export * from "./FolderName.vue?vue&type=script&lang=js&"
import style0 from "./FolderName.vue?vue&type=style&index=0&id=91f9e248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f9e248",
  null
  
)

export default component.exports